import { useState } from "react";
import { Chart } from "react-google-charts";
import moment from "moment";

const TransactionCharts = ({ data, setUserId }) => {
  const [show_details, setShowDetails] = useState(false);

  const balance_summary_chart_data = data.balance_summary.map(
    ({ date, amount_above, amount_below, balance_after_total }) => [
      moment(date).format("DD-MM-YYYY"),
      amount_above,
      amount_below,
      balance_after_total,
    ]
  );

  return (
    <div className="dashboard">
      <Chart
        options={{
          colors: ["#5D78FF"],
          chartArea: { width: "90%" },
          hAxis: {
            textStyle: {
              fontSize: 12,
              color: "#595D6E",
            },
          },
          vAxis: {
            textStyle: {
              fontSize: 12,
              color: "#595D6E",
            },
          },
          seriesType: "bars",
          series: {
            0: { color: "#28a745" },
            1: { color: "#dc3545" },
            2: { type: "line" },
          },
          legend: { position: "none" },
        }}
        chartType="ComboChart"
        loader={null}
        width="100%"
        height="400px"
        data={[
          ["Data", "Ilość na plus", "Ilość na minus", "Saldo po"],
          ...balance_summary_chart_data,
        ]}
      />
      <div className="row p-20 jc-fe">
        <button
          type="button"
          className="btn btn-blue btn-collapse"
          onClick={() => setShowDetails(!show_details)}
          style={{ paddingRight: 5 }}
        >
          <span style={{ color: "#fff" }}>
            {!show_details ? "Pokaż" : "Zwiń"} szczegóły
          </span>
          <svg
            height="20"
            width="20"
            viewBox="0 0 20 20"
            aria-hidden="true"
            style={{
              marginLeft: 5,
              transform: `scaleY(${!show_details ? "1" : "-1"})`,
            }}
          >
            <path
              fill="#fff"
              d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
            />
          </svg>
        </button>
      </div>
      {show_details && (
        <div className="row wrap">
          {data.all_packer_stats.map(({ user, transactions }) => {
            const chart_data =
              transactions?.length > 0
                ? transactions.map(({ reported_at, balance_after }) => [
                    reported_at,
                    balance_after,
                  ])
                : [[0, 0]];

            const total_balance_after = transactions.reduce(
              (acc, { balance_after }) => acc + balance_after,
              0
            );

            if (total_balance_after === 0) {
              return null;
            }

            return (
              <div className="p-10 box-3" key={user.id}>
                <p
                  className="text-underline text-pointer"
                  onClick={() => setUserId(user.id)}
                >
                  {user.full_name}
                </p>
                <Chart
                  options={{
                    colors: ["#5D78FF"],
                    chartArea: { width: "80%" },
                    vAxis: { minValue: 0, maxValue: 1000 },
                    hAxis: {
                      textStyle: {
                        fontSize: 10,
                        color: "#595D6E",
                      },
                    },
                    curveType: "function",
                    legend: { position: "none" },
                  }}
                  chartType="LineChart"
                  loader={null}
                  width="100%"
                  data={[["Data", "Saldo po"], ...chart_data]}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TransactionCharts;
